/* eslint-disable */
export enum AppActionTypes {
  SET_SITE_CONTEXT = "@@App/SET_SITE_CONTEXT",
  SET_SELECTED_ROLES = "@@App/SET_SELECTED_ROLES",
  SET_SHOW_ALARM_NOTIFICATION = "@@App/SET_SHOW_ALARM_NOTIFICATION",
  SET_MODAL_STATUS = "@@App/SET_MODAL_STATUS"
}

export default AppActionTypes;